import { PAYMENT } from "./order";
export const NOT_FOUND_INDEX = -1;

export const DAYS = {
  Monday: "Lundi",
  Tuesday: "Mardi",
  Wednesday: "Mercredi",
  Thursday: "Jeudi",
  Friday: "Vendredi",
  Saturday: "Samedi",
  Sunday: "Dimanche",
};

export const ONLINE_PAYMENTS = [PAYMENT.TYPE_STRIPE];

export const ICONS = {
  Close: "close",
  ChevronRight: "ChevronRight",
  Plus: "Plus",
  CreditCard: "creditCard",
  BanknoteArrowDown: "BanknoteArrowDown",
  HandCoins: "HandCoins",
  Coins: "Coins",
  Ticket: "Tickets",
  Pencil: "Pencil",
  Clock: "clock",
  PackageCheck: "PackageCheck",
  Store: "Store",
  Bike: "Bike",
  CircleCheck: "CircleCheck",
  Search: "Search",
  House: "House",
  Lock: "lock",
  Info: "info",
  Calendar: "Calendar",
  Minus: "Minus",
  Locate: "Locate"
};
